import React from "react";
import styled from "styled-components";

interface Props {
  header: string;
  paragraph: string;
}

export const SectionHeader = styled.div`
  font-size: var(--global-font-size-l);
  margin-bottom: 12px;
`;

export const SectionContent = styled.div`
  font-size: var(--global-font-size-s);
  line-height: 2;
`;

export const SectionText: React.FC<Props> = ({ header, paragraph }) => {
  return (
    <div>
      <SectionHeader>{header}</SectionHeader>
      <SectionContent>{paragraph}</SectionContent>
    </div>
  );
};
